import ItemDropdown from './item_dropdown';

/**
 * Factory to create handlers for items
 */
class ItemFactory {
    /**
     * Get item quantity dropdowns
     */
    getDropdowns($context) {
        var dropdowns = [];
        $context.find('.qty__select').each(function (ind, elm) {
            dropdowns.push(new ItemDropdown($(elm)));
        });
        return dropdowns;
    }
}

export default ItemFactory;